import React from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles,
	Typography
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	topicContainer: {
		fontSize: "0.9rem"
	},

	topic: {
		fontWeight: 700
	}
}));

function ActivityTopics(props) {
	let allTopics = [],
		multipleTopics = false,
		classes = styles(),
		{matches, topics, includeLabel, className} = props;

	// post matches OR topics
	if (matches && matches.length) {
		matches.map(match => {
			if (match.library_topic && match.library_topic.name && !allTopics.includes(match.library_topic.name)) {
				allTopics.push(match.library_topic.name);
			}
			return allTopics;
		});
	} else if (topics && topics.length) {
		topics.map(topic => {
			if (topic.name && !allTopics.includes(topic.name)) {
				allTopics.push(topic.name);
			}
			return allTopics;
		});
	}

	multipleTopics = allTopics.length > 1;

	return (
		allTopics.length > 0 ?
			<Typography className={`${classes.topicContainer} ${className}`}>
				{includeLabel ? <span>{multipleTopics ? "Topics: " : "Topic: "}</span> : null}
				{allTopics.map((topic, i) =>
					<span className={classes.topic} key={`key-${topic}`}>{topic}{(allTopics.length !== i + 1) ? ", " : null}</span>
				)}
			</Typography> : null
	);
}

ActivityTopics.defaultProps = {
	includeLabel: false
};

ActivityTopics.propTypes = {
	matches: PropTypes.array,
	topics: PropTypes.array,
	includeLabel: PropTypes.bool,
	className: PropTypes.string
};

export default ActivityTopics;